import { AppTester } from "../../../supporting";
import styled from "styled-components";
import { Colors, ExternalLink, FlexBox, NavbarThreeLinesIcon, NeutralLink, useBreakpoint, useIsMobile } from "@brg/ui";
import { LayoutConst, useModal } from "../../../core";
import { useHistory, useLocation, useRouteMatch } from "react-router-dom";
import { FC, useCallback, useMemo } from "react";
import { isServer } from "shared/constants/isServer";
import extractDomain from "shared/utils/extractDomain";

const MediiiaLogoWrapper = styled.div<{ isFooter?: boolean }>`
    border-radius: 0px 8px 8px 0px;
    background: ${Colors.galBlack100};
    color: ${({ isFooter }) => isFooter ? Colors.galBlack100 : Colors.geoWhite100};
    padding: 6px 24px 6px 32px;
    align-items: center;
    display: flex;
    height: 38px;
    font-family: 'Inter';

    font-size: 20px;
    font-style: normal;
    font-weight: 700;
    line-height: 25px; 
    letter-spacing: -0.02em;
    gap: 8px;
    margin-left: -32px;
    
    @media(max-width: ${LayoutConst.screen.l_16}px) {
        margin-left: -26px;
    }

    @media (max-width: ${LayoutConst.screen.mac13}px), (max-height: ${LayoutConst.screen.height.projectCover}px) {
        font-size: 17px;
        line-height: 22px;
        height: 36px;
    }

    @media(max-width: ${LayoutConst.screen.l_12}px) {
        margin-left: -16px;
    }

    @media(max-width: ${LayoutConst.screen.m}px) {
        padding: 5px 16px 5px 22px;
        height: 32px;

        place-items: center;
        justify-content: flex-start;

        gap: 8px;
    }
`

const MediiiaIcon = () => {
    return <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <mask id="path-1-outside-1_2181_22863" maskUnits="userSpaceOnUse" x="0.398438" y="3.40039" width="23"
            height="17" fill="black">
            <rect fill="white" x="0.398438" y="3.40039" width="23" height="17" />
            <path fillRule="evenodd" clipRule="evenodd"
                d="M1.39844 5.00039C1.39844 4.66902 1.66707 4.40039 1.99844 4.40039H21.9984C22.3298 4.40039 22.5984 4.66902 22.5984 5.00039C22.5984 5.33176 22.3298 5.60039 21.9984 5.60039H1.99844C1.66707 5.60039 1.39844 5.33176 1.39844 5.00039ZM1.39844 12.0004C1.39844 11.669 1.66707 11.4004 1.99844 11.4004H21.9984C22.3298 11.4004 22.5984 11.669 22.5984 12.0004C22.5984 12.3318 22.3298 12.6004 21.9984 12.6004H1.99844C1.66707 12.6004 1.39844 12.3318 1.39844 12.0004ZM1.39844 19.0004C1.39844 18.669 1.66707 18.4004 1.99844 18.4004H21.9984C22.3298 18.4004 22.5984 18.669 22.5984 19.0004C22.5984 19.3318 22.3298 19.6004 21.9984 19.6004H1.99844C1.66707 19.6004 1.39844 19.3318 1.39844 19.0004Z" />
        </mask>
        <path fillRule="evenodd" clipRule="evenodd"
            d="M1.39844 5.00039C1.39844 4.66902 1.66707 4.40039 1.99844 4.40039H21.9984C22.3298 4.40039 22.5984 4.66902 22.5984 5.00039C22.5984 5.33176 22.3298 5.60039 21.9984 5.60039H1.99844C1.66707 5.60039 1.39844 5.33176 1.39844 5.00039ZM1.39844 12.0004C1.39844 11.669 1.66707 11.4004 1.99844 11.4004H21.9984C22.3298 11.4004 22.5984 11.669 22.5984 12.0004C22.5984 12.3318 22.3298 12.6004 21.9984 12.6004H1.99844C1.66707 12.6004 1.39844 12.3318 1.39844 12.0004ZM1.39844 19.0004C1.39844 18.669 1.66707 18.4004 1.99844 18.4004H21.9984C22.3298 18.4004 22.5984 18.669 22.5984 19.0004C22.5984 19.3318 22.3298 19.6004 21.9984 19.6004H1.99844C1.66707 19.6004 1.39844 19.3318 1.39844 19.0004Z"
            fill="#FEFEFE" />
        <path
            d="M1.99844 3.90039C1.39092 3.90039 0.898438 4.39288 0.898438 5.00039H1.89844C1.89844 4.94516 1.94321 4.90039 1.99844 4.90039V3.90039ZM21.9984 3.90039H1.99844V4.90039H21.9984V3.90039ZM23.0984 5.00039C23.0984 4.39288 22.6059 3.90039 21.9984 3.90039V4.90039C22.0537 4.90039 22.0984 4.94516 22.0984 5.00039H23.0984ZM21.9984 6.10039C22.6059 6.10039 23.0984 5.6079 23.0984 5.00039H22.0984C22.0984 5.05562 22.0537 5.10039 21.9984 5.10039V6.10039ZM1.99844 6.10039H21.9984V5.10039H1.99844V6.10039ZM0.898438 5.00039C0.898438 5.6079 1.39092 6.10039 1.99844 6.10039V5.10039C1.94321 5.10039 1.89844 5.05562 1.89844 5.00039H0.898438ZM1.99844 10.9004C1.39092 10.9004 0.898438 11.3929 0.898438 12.0004H1.89844C1.89844 11.9452 1.94321 11.9004 1.99844 11.9004V10.9004ZM21.9984 10.9004H1.99844V11.9004H21.9984V10.9004ZM23.0984 12.0004C23.0984 11.3929 22.6059 10.9004 21.9984 10.9004V11.9004C22.0537 11.9004 22.0984 11.9452 22.0984 12.0004H23.0984ZM21.9984 13.1004C22.606 13.1004 23.0984 12.6079 23.0984 12.0004H22.0984C22.0984 12.0556 22.0537 12.1004 21.9984 12.1004V13.1004ZM1.99844 13.1004H21.9984V12.1004H1.99844V13.1004ZM0.898438 12.0004C0.898438 12.6079 1.39093 13.1004 1.99844 13.1004V12.1004C1.94321 12.1004 1.89844 12.0556 1.89844 12.0004H0.898438ZM1.99844 17.9004C1.39093 17.9004 0.898438 18.3929 0.898438 19.0004H1.89844C1.89844 18.9452 1.94321 18.9004 1.99844 18.9004V17.9004ZM21.9984 17.9004H1.99844V18.9004H21.9984V17.9004ZM23.0984 19.0004C23.0984 18.3929 22.606 17.9004 21.9984 17.9004V18.9004C22.0537 18.9004 22.0984 18.9452 22.0984 19.0004H23.0984ZM21.9984 20.1004C22.606 20.1004 23.0984 19.6079 23.0984 19.0004H22.0984C22.0984 19.0556 22.0537 19.1004 21.9984 19.1004V20.1004ZM1.99844 20.1004H21.9984V19.1004H1.99844V20.1004ZM0.898438 19.0004C0.898438 19.6079 1.39093 20.1004 1.99844 20.1004V19.1004C1.94321 19.1004 1.89844 19.0556 1.89844 19.0004H0.898438Z"
            fill="#FEFEFE" mask="url(#path-1-outside-1_2181_22863)" />
    </svg>

}

const CloseIconWithBorder = ({ }) => (
    <svg width="24" height="24" viewBox="0 0 24 24" fill='transparent'>
        <rect x="2.75" y="2.75" width="18.5" height="18.5" rx="2.25" stroke="rgba(254,254,254,1)" strokeWidth="1.5"></rect>
        <path d="M12 12.4143L9.49014 14.9241C9.38902 15.0252 9.22426 15.0258 9.12484 14.923C9.10256 14.9 9.09007 14.8866 9.08261 14.8783C8.98528 14.77 8.97764 14.608 9.0806 14.505L11.5857 12L9.07584 9.49014C8.97472 9.38902 8.97472 9.22507 9.07584 9.12395L9.12395 9.07584C9.22507 8.97472 9.38902 8.97472 9.49014 9.07584L12 11.5857L14.5098 9.07584C14.6109 8.97472 14.7749 8.97472 14.876 9.07584L14.9241 9.12395C15.0252 9.22507 15.0252 9.38902 14.9241 9.49014L12.4143 12L14.9241 14.5098C15.0252 14.6109 15.0258 14.7757 14.923 14.8751C14.9 14.8974 14.8866 14.9099 14.8783 14.9173C14.77 15.0146 14.608 15.0223 14.505 14.9193L12 12.4143Z" fill="rgba(254,254,254,1)" stroke="rgba(254,254,254,1)" strokeLinecap="round" strokeLinejoin="round"></path>
    </svg>
);

export const MediiiaLogo: FC<{ onBurgerClick: () => void; visiblePopUp?: boolean; isFooter?: boolean }> = ({ onBurgerClick = () => { }, visiblePopUp, isFooter }) => {

    const isLecture = AppTester.isLectureMediiia();
    const isCreative = AppTester.isContext('creativemediiia');
    const isHistory = AppTester.isContext('historymediiia');
    const isTransfer = AppTester.isContext('transfermediiia');
    const isSport = AppTester.isContext('sportmediiia');
    const isProf = AppTester.isContext('profmediiia');
    const isPhoto = AppTester.isContext('photomediiia');
    const isAi = AppTester.isContext('aimediiia');
    const isConcept = AppTester.isContext('conceptmediiia');
    const isCine = AppTester.isContext('cinemediiia');
    const isEvent = AppTester.isContext('eventmediiia');
    const isScience = AppTester.isScienceMediiia();
    const isMusic = AppTester.isContext('musicmediiia');
    const isStories = AppTester.isContext('storiesmediiia');
    const isDesign = AppTester.isContext('designmediiia');
    const isArt = AppTester.isContext('artmediiia');
    const isUrban = AppTester.isContext('urbanmediiia');
    const isFashion = AppTester.isContext('fashionmediiia');
    const isFood = AppTester.isContext('foodmediiia');
    const isAuto = AppTester.isContext('automediiia');
    const isNature = AppTester.isContext('naturemediiia')
    const isMediaMain = AppTester.isContext('mediiia');
    const { pathname } = useLocation();
    const isCompetitions = pathname.startsWith('/competition') || pathname.startsWith('/awards');
    const isMediiiaResearch = !!useRouteMatch('/research')?.isExact;
    const isBooks = AppTester.isContext('booksmediiia');
    const history = useHistory()
    const modal = useModal()
    const isMobile = useBreakpoint(LayoutConst.screen.m);
    const isTablet = useBreakpoint(LayoutConst.screen.l);

    const contextHref = useMemo(() => {
        if (isLecture) {
            if (!isServer) {
                const url = window.location.host.includes('.ru')
                    ? process.env.REACT_APP_URL_EDUCATION_MEDIIIA_RU
                    : process.env.REACT_APP_URL_EDUCATION_MEDIIIA_COM;
                return url;
            }
            return '/';
        }

        return '/';
    }, [isLecture, isServer, history]);

    const logoHref = useMemo(() => {
        if (isMediaMain) {
            return '/';
        }
        return window.location.host.includes('.ru') ? process.env.REACT_APP_URL_MEDIIIA_RU : process.env.REACT_APP_URL_MEDIIIA_COM;
    }, [isMediaMain]);




    //@ts-ignore
    const handleBurgerClick = useCallback((e) => {
        e.stopPropagation()
        if (isTablet) {
            onBurgerClick && onBurgerClick();
            return;
        }
        modal.show('context-new');


    }, [modal, onBurgerClick, isMobile]);

    const getPrefixNameAndColor = () => {
        if (isFooter) {
            return ['', '#f2f2f2']
        }
        if (isConcept) {
            return ['concept', '#000000']
        }
        if (isMusic) {
            return ['sound', '#6F359C']
        }
        if (isStories) {
            return ['stories', '#00EB12']
        }
        if (isEvent) {
            return ['365', '#151514']
        }
        if (isCreative) {
            return ['creative', '#4CA830']
        }
        if (isDesign) {
            return ['design', '#D10000']
        }
        if (isArt) {
            return ['art', '#3F4548']
        }
        if (isProf) {
            return ['profi', '#3F4548']
        }
        if (isAi) {
            return ['ai', '#3F4548']
        }
        if (isPhoto) {
            return ['photo', '#3F4548']
        }
        if (isCine) {
            return ['cine', '#3F4548']
        }
        if (isUrban) {
            return ['urban', '#29894E']
        }
        if (isFashion) {
            return ['fashion', '#4CA830']
        }
        if (isFood) {
            return ['food', '#C973C5']
        }

        if (isSport) {
            return ['sport', '#43C279']
        }

        if (isLecture) {
            return ['education', '#FF4C20']
        }

        if (isHistory) {
            return ['history', '#146DEE']
        }
        if (isTransfer) {
            return ['transfer', 'hotpink']
        }
        if (isScience) {
            return ['science', '#5689EC']
        }

        if (isMediiiaResearch) {
            return ['research', '#151514']
        }
        if (isBooks) {
            return ['books', '#151514']
        }
        if (isAuto) {
            return ['auto', '#151514']
        }
        if (isNature) {
            return ['astro', '#43C279']
        }
        if (AppTester.isNamesMediiia()) {
            return ['names', '#151514']
        }
        if (isCompetitions) {
            return ['awards', '#343434']
        }

        return ['', '#151514'];
    }

    return <MediiiaLogoWrapper isFooter={isFooter} style={{ background: getPrefixNameAndColor()[1] }}>
        {!isFooter && <div onClick={handleBurgerClick}>{visiblePopUp ? <CloseIconWithBorder /> : (isTablet ? <NavbarThreeLinesIcon fill={Colors.geoWhite100} /> : <MediiiaIcon />)}</div>}
        <FlexBox>
            <ExternalLink to={contextHref} title={extractDomain(contextHref)}>
                <span>{`${getPrefixNameAndColor()[0]?.length > 0 ? getPrefixNameAndColor()[0] + '.' : ''}`}</span>
            </ExternalLink>
            <ExternalLink to={logoHref} title={extractDomain(logoHref)}>
                <span>mediiia</span>
            </ExternalLink>
        </FlexBox>
    </MediiiaLogoWrapper>
}import { AppTester } from "../../../supporting";
import styled from "styled-components";
import { Colors, ExternalLink, FlexBox, NavbarThreeLinesIcon, NeutralLink, useBreakpoint, useIsMobile } from "@brg/ui";
import { LayoutConst, useModal } from "../../../core";
import { useHistory, useLocation, useRouteMatch } from "react-router-dom";
import { FC, useCallback, useMemo } from "react";
import { isServer } from "shared/constants/isServer";
import extractDomain from "shared/utils/extractDomain";

const MediiiaLogoWrapper = styled.div<{ isFooter?: boolean }>`
    border-radius: 0px 8px 8px 0px;
    background: ${Colors.galBlack100};
    color: ${({ isFooter }) => isFooter ? Colors.galBlack100 : Colors.geoWhite100};
    padding: 6px 24px 6px 32px;
    align-items: center;
    display: flex;
    height: 38px;
    font-family: 'Inter';

    font-size: 20px;
    font-style: normal;
    font-weight: 700;
    line-height: 25px; 
    letter-spacing: -0.02em;
    gap: 8px;
    margin-left: -32px;
    
    @media(max-width: ${LayoutConst.screen.l_16}px) {
        margin-left: -26px;
    }

    @media (max-width: ${LayoutConst.screen.mac13}px), (max-height: ${LayoutConst.screen.height.projectCover}px) {
        font-size: 17px;
        line-height: 22px;
        height: 36px;
    }

    @media(max-width: ${LayoutConst.screen.l_12}px) {
        margin-left: -16px;
    }

    @media(max-width: ${LayoutConst.screen.m}px) {
        padding: 5px 16px 5px 22px;
        height: 32px;

        place-items: center;
        justify-content: flex-start;

        gap: 8px;
    }
`

const MediiiaIcon = () => {
    return <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <mask id="path-1-outside-1_2181_22863" maskUnits="userSpaceOnUse" x="0.398438" y="3.40039" width="23"
            height="17" fill="black">
            <rect fill="white" x="0.398438" y="3.40039" width="23" height="17" />
            <path fillRule="evenodd" clipRule="evenodd"
                d="M1.39844 5.00039C1.39844 4.66902 1.66707 4.40039 1.99844 4.40039H21.9984C22.3298 4.40039 22.5984 4.66902 22.5984 5.00039C22.5984 5.33176 22.3298 5.60039 21.9984 5.60039H1.99844C1.66707 5.60039 1.39844 5.33176 1.39844 5.00039ZM1.39844 12.0004C1.39844 11.669 1.66707 11.4004 1.99844 11.4004H21.9984C22.3298 11.4004 22.5984 11.669 22.5984 12.0004C22.5984 12.3318 22.3298 12.6004 21.9984 12.6004H1.99844C1.66707 12.6004 1.39844 12.3318 1.39844 12.0004ZM1.39844 19.0004C1.39844 18.669 1.66707 18.4004 1.99844 18.4004H21.9984C22.3298 18.4004 22.5984 18.669 22.5984 19.0004C22.5984 19.3318 22.3298 19.6004 21.9984 19.6004H1.99844C1.66707 19.6004 1.39844 19.3318 1.39844 19.0004Z" />
        </mask>
        <path fillRule="evenodd" clipRule="evenodd"
            d="M1.39844 5.00039C1.39844 4.66902 1.66707 4.40039 1.99844 4.40039H21.9984C22.3298 4.40039 22.5984 4.66902 22.5984 5.00039C22.5984 5.33176 22.3298 5.60039 21.9984 5.60039H1.99844C1.66707 5.60039 1.39844 5.33176 1.39844 5.00039ZM1.39844 12.0004C1.39844 11.669 1.66707 11.4004 1.99844 11.4004H21.9984C22.3298 11.4004 22.5984 11.669 22.5984 12.0004C22.5984 12.3318 22.3298 12.6004 21.9984 12.6004H1.99844C1.66707 12.6004 1.39844 12.3318 1.39844 12.0004ZM1.39844 19.0004C1.39844 18.669 1.66707 18.4004 1.99844 18.4004H21.9984C22.3298 18.4004 22.5984 18.669 22.5984 19.0004C22.5984 19.3318 22.3298 19.6004 21.9984 19.6004H1.99844C1.66707 19.6004 1.39844 19.3318 1.39844 19.0004Z"
            fill="#FEFEFE" />
        <path
            d="M1.99844 3.90039C1.39092 3.90039 0.898438 4.39288 0.898438 5.00039H1.89844C1.89844 4.94516 1.94321 4.90039 1.99844 4.90039V3.90039ZM21.9984 3.90039H1.99844V4.90039H21.9984V3.90039ZM23.0984 5.00039C23.0984 4.39288 22.6059 3.90039 21.9984 3.90039V4.90039C22.0537 4.90039 22.0984 4.94516 22.0984 5.00039H23.0984ZM21.9984 6.10039C22.6059 6.10039 23.0984 5.6079 23.0984 5.00039H22.0984C22.0984 5.05562 22.0537 5.10039 21.9984 5.10039V6.10039ZM1.99844 6.10039H21.9984V5.10039H1.99844V6.10039ZM0.898438 5.00039C0.898438 5.6079 1.39092 6.10039 1.99844 6.10039V5.10039C1.94321 5.10039 1.89844 5.05562 1.89844 5.00039H0.898438ZM1.99844 10.9004C1.39092 10.9004 0.898438 11.3929 0.898438 12.0004H1.89844C1.89844 11.9452 1.94321 11.9004 1.99844 11.9004V10.9004ZM21.9984 10.9004H1.99844V11.9004H21.9984V10.9004ZM23.0984 12.0004C23.0984 11.3929 22.6059 10.9004 21.9984 10.9004V11.9004C22.0537 11.9004 22.0984 11.9452 22.0984 12.0004H23.0984ZM21.9984 13.1004C22.606 13.1004 23.0984 12.6079 23.0984 12.0004H22.0984C22.0984 12.0556 22.0537 12.1004 21.9984 12.1004V13.1004ZM1.99844 13.1004H21.9984V12.1004H1.99844V13.1004ZM0.898438 12.0004C0.898438 12.6079 1.39093 13.1004 1.99844 13.1004V12.1004C1.94321 12.1004 1.89844 12.0556 1.89844 12.0004H0.898438ZM1.99844 17.9004C1.39093 17.9004 0.898438 18.3929 0.898438 19.0004H1.89844C1.89844 18.9452 1.94321 18.9004 1.99844 18.9004V17.9004ZM21.9984 17.9004H1.99844V18.9004H21.9984V17.9004ZM23.0984 19.0004C23.0984 18.3929 22.606 17.9004 21.9984 17.9004V18.9004C22.0537 18.9004 22.0984 18.9452 22.0984 19.0004H23.0984ZM21.9984 20.1004C22.606 20.1004 23.0984 19.6079 23.0984 19.0004H22.0984C22.0984 19.0556 22.0537 19.1004 21.9984 19.1004V20.1004ZM1.99844 20.1004H21.9984V19.1004H1.99844V20.1004ZM0.898438 19.0004C0.898438 19.6079 1.39093 20.1004 1.99844 20.1004V19.1004C1.94321 19.1004 1.89844 19.0556 1.89844 19.0004H0.898438Z"
            fill="#FEFEFE" mask="url(#path-1-outside-1_2181_22863)" />
    </svg>

}

const CloseIconWithBorder = ({ }) => (
    <svg width="24" height="24" viewBox="0 0 24 24" fill='transparent'>
        <rect x="2.75" y="2.75" width="18.5" height="18.5" rx="2.25" stroke="rgba(254,254,254,1)" strokeWidth="1.5"></rect>
        <path d="M12 12.4143L9.49014 14.9241C9.38902 15.0252 9.22426 15.0258 9.12484 14.923C9.10256 14.9 9.09007 14.8866 9.08261 14.8783C8.98528 14.77 8.97764 14.608 9.0806 14.505L11.5857 12L9.07584 9.49014C8.97472 9.38902 8.97472 9.22507 9.07584 9.12395L9.12395 9.07584C9.22507 8.97472 9.38902 8.97472 9.49014 9.07584L12 11.5857L14.5098 9.07584C14.6109 8.97472 14.7749 8.97472 14.876 9.07584L14.9241 9.12395C15.0252 9.22507 15.0252 9.38902 14.9241 9.49014L12.4143 12L14.9241 14.5098C15.0252 14.6109 15.0258 14.7757 14.923 14.8751C14.9 14.8974 14.8866 14.9099 14.8783 14.9173C14.77 15.0146 14.608 15.0223 14.505 14.9193L12 12.4143Z" fill="rgba(254,254,254,1)" stroke="rgba(254,254,254,1)" strokeLinecap="round" strokeLinejoin="round"></path>
    </svg>
);

export const MediiiaLogo: FC<{ onBurgerClick: () => void; visiblePopUp?: boolean; isFooter?: boolean }> = ({ onBurgerClick = () => { }, visiblePopUp, isFooter }) => {

    const isLecture = AppTester.isLectureMediiia();
    const isCreative = AppTester.isContext('creativemediiia');
    const isHistory = AppTester.isContext('historymediiia');
    const isTransfer = AppTester.isContext('transfermediiia');
    const isSport = AppTester.isContext('sportmediiia');
    const isProf = AppTester.isContext('profmediiia');
    const isPhoto = AppTester.isContext('photomediiia');
    const isAi = AppTester.isContext('aimediiia');
    const isConcept = AppTester.isContext('conceptmediiia');
    const isCine = AppTester.isContext('cinemediiia');
    const isEvent = AppTester.isContext('eventmediiia');
    const isScience = AppTester.isScienceMediiia();
    const isMusic = AppTester.isContext('musicmediiia');
    const isStories = AppTester.isContext('storiesmediiia');
    const isDesign = AppTester.isContext('designmediiia');
    const isArt = AppTester.isContext('artmediiia');
    const isUrban = AppTester.isContext('urbanmediiia');
    const isFashion = AppTester.isContext('fashionmediiia');
    const isFood = AppTester.isContext('foodmediiia');
    const isAuto = AppTester.isContext('automediiia');
    const isNature = AppTester.isContext('naturemediiia')
    const isMediaMain = AppTester.isContext('mediiia');
    const { pathname } = useLocation();
    const isCompetitions = pathname.startsWith('/competition') || pathname.startsWith('/awards');
    const isMediiiaResearch = !!useRouteMatch('/research')?.isExact;
    const isBooks = AppTester.isContext('booksmediiia');
    const history = useHistory()
    const modal = useModal()
    const isMobile = useBreakpoint(LayoutConst.screen.m);
    const isTablet = useBreakpoint(LayoutConst.screen.l);

    const contextHref = useMemo(() => {
        if (isLecture) {
            if (!isServer) {
                const url = window.location.host.includes('.ru')
                    ? process.env.REACT_APP_URL_EDUCATION_MEDIIIA_RU
                    : process.env.REACT_APP_URL_EDUCATION_MEDIIIA_COM;
                return url;
            }
            return '/';
        }

        return '/';
    }, [isLecture, isServer, history]);

    const logoHref = useMemo(() => {
        if (isMediaMain) {
            return '/';
        }
        return window.location.host.includes('.ru') ? process.env.REACT_APP_URL_MEDIIIA_RU : process.env.REACT_APP_URL_MEDIIIA_COM;
    }, [isMediaMain]);




    //@ts-ignore
    const handleBurgerClick = useCallback((e) => {
        e.stopPropagation()
        if (isTablet) {
            onBurgerClick && onBurgerClick();
            return;
        }
        modal.show('context-new');


    }, [modal, onBurgerClick, isMobile]);

    const getPrefixNameAndColor = () => {
        if (isFooter) {
            return ['', '#f2f2f2']
        }
        if (isConcept) {
            return ['concept', '#000000']
        }
        if (isMusic) {
            return ['sound', '#6F359C']
        }
        if (isStories) {
            return ['stories', '#00EB12']
        }
        if (isEvent) {
            return ['365', '#151514']
        }
        if (isCreative) {
            return ['creative', '#4CA830']
        }
        if (isDesign) {
            return ['design', '#D10000']
        }
        if (isArt) {
            return ['art', '#3F4548']
        }
        if (isProf) {
            return ['profi', '#3F4548']
        }
        if (isAi) {
            return ['ai', '#3F4548']
        }
        if (isPhoto) {
            return ['photo', '#3F4548']
        }
        if (isCine) {
            return ['cine', '#3F4548']
        }
        if (isUrban) {
            return ['urban', '#29894E']
        }
        if (isFashion) {
            return ['fashion', '#4CA830']
        }
        if (isFood) {
            return ['food', '#C973C5']
        }

        if (isSport) {
            return ['sport', '#43C279']
        }

        if (isLecture) {
            return ['education', '#FF4C20']
        }

        if (isHistory) {
            return ['history', '#146DEE']
        }
        if (isTransfer) {
            return ['transfer', 'hotpink']
        }
        if (isScience) {
            return ['science', '#5689EC']
        }

        if (isMediiiaResearch) {
            return ['research', '#151514']
        }
        if (isBooks) {
            return ['books', '#151514']
        }
        if (isAuto) {
            return ['auto', '#151514']
        }
        if (isNature) {
            return ['astro', '#43C279']
        }
        if (AppTester.isNamesMediiia()) {
            return ['names', '#151514']
        }
        if (isCompetitions) {
            return ['awards', '#343434']
        }

        return ['', '#151514'];
    }

    return <MediiiaLogoWrapper isFooter={isFooter} style={{ background: getPrefixNameAndColor()[1] }}>
        {!isFooter && <div onClick={handleBurgerClick}>{visiblePopUp ? <CloseIconWithBorder /> : (isTablet ? <NavbarThreeLinesIcon fill={Colors.geoWhite100} /> : <MediiiaIcon />)}</div>}
        <FlexBox>
            <ExternalLink to={contextHref} title={extractDomain(contextHref)}>
                <span>{`${getPrefixNameAndColor()[0]?.length > 0 ? getPrefixNameAndColor()[0] + '.' : ''}`}</span>
            </ExternalLink>
            <ExternalLink to={logoHref} title={extractDomain(logoHref)}>
                <span>mediiia</span>
            </ExternalLink>
        </FlexBox>
    </MediiiaLogoWrapper>
}